import { useDrag } from "react-dnd";
import Badge from "react-bootstrap/Badge";

function Words(props) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "word",
    item: { id: props.id, name: props.name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  return (
    <Badge
      pill
      bg="info"
      text="dark"
      ref={drag}
      key={props.id}
      id={props.id}
      variant="outline-primary"
      style={{
        marginTop: "5px",
        width: "250px",
        margin: "5px",
        border: isDragging ? "5px solid #e7b8ff" : "5px solid #0ACDF0",
      }}
    >
      <h1
        style={{
          color: isDragging ? "#e7b8ff" : "#fff",
        }}
      >
        {props.name}
      </h1>
    </Badge>
  );
}
export default Words;
